import React, { useState, useEffect, useCallback } from 'react'
import { useModal } from 'react-modal-hook'
import TermsConditionService from '../../services/terms-and-conditions.service'
import TermsModal from '../Modal/termsModal'
import envConfig from 'custom/config/environment'
import { SIDENAV_KEYS } from '../../utils/translation-constants'
import { useTranslation } from 'react-i18next'
import ReactModal from 'react-modal'
import NeoButton from '../NeoButton/NeoButton'

export default function SignUpTermsAndCondition({ module = '', setIsTermAccepted , tabIndex=''}) {
  const [dataSource, setDataSource] = useState({})
  const { t } = useTranslation()
  const [accepted, setAccepted] = useState(false)

  const fetchTermsAndConditions = useCallback(async () => {
    try {
      const response = await TermsConditionService.getTermsAndConditions({
        module: envConfig.TC_MODULE_TYPE === 'CUSTOM' ? module : 'GENERAL',
      })
      if (response.data['termsAndCondition']) {
        setDataSource(response.data['termsAndCondition'][0])
      }
    } catch (err) {}
  }, [])

  useEffect(() => {
    fetchTermsAndConditions()
  }, [])

  const handleScroll = useCallback(
    (e) => {
      if (accepted) {
        return;
      }
      const bottom =
        Math.round(e.target.scrollHeight - e.target.scrollTop) === Math.round(e.target.clientHeight)
      setAccepted(bottom)
      setIsTermAccepted(bottom)
    },
    [accepted],
  )

  const [showModal, hideModal] = useModal(
    () => (
      <ReactModal
        isOpen
        style={{
          content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            border: 'none',
            maxWidth: '550px',
            width: '50% !important',
            borderRadius: '20px',
            marginRight: '-50%',
            boxShadow: '0 0 10px #AAAAAA',
            transform: 'translate(-50%, -50%)',
          },
        }}>
        <div className='d-flex flex-column'>
          <h4 className='heading-style' style={{ margin: 0 }}>
            Terms And Conditions
          </h4>
          <div className='row justify-content-center align-items-center'>
            <div className='col-12' style={{ padding: 0 }}>
              <div className='modal-error-body'>
                <div>
                  <p
                    onScroll={(e) => (!accepted ? handleScroll(e) : null)}
                    dangerouslySetInnerHTML={{ __html: dataSource?.message || '' }}
                    className='text-justify'
                    style={{
                      height: 300,
                      padding: 20,
                      overflow: 'overlay',
                      whiteSpace: 'pre-line',
                    }}></p>
                </div>
              </div>
            </div>
          </div>
          <div className='modal-btn-style' style={{ marginTop: 0 }}>
            <NeoButton
              mode='newDesign'
              type='button'
              disabled={!accepted}
              text={accepted ? 'Accepted' : 'Accept'}
              onClick={() => {
                hideModal()
              }}
            />
          </div>
        </div>
      </ReactModal>
    ),
    [dataSource, accepted],
  )

  return (
    <div>
      <label
        className='form-check-label control-label'
        style={{ margin: '0 auto', display: 'flex', alignItems: 'center' }}
        htmlFor='tnc'>
        <span style={{ marginRight: 10 }}>
          <input
          tabIndex={tabIndex}
            onChange={(event) => {
              setAccepted(event.target.checked)
              setIsTermAccepted(event.target.checked)
            }}
            type='checkbox'
            id='check1'
          />
        </span>
        <label htmlFor='check1'>
          {t(SIDENAV_KEYS.TERMS_AND_CONDITIONS_KEYS.CONFIRM_TERMS_CONDITION)}
          <span
            onClick={(e) => {
              e.preventDefault()
              e.stopPropagation()
              showModal()
            }}
            style={{ color: 'blue', cursor: 'pointer' }}
            type='button'
            data-toggle='modal'
            data-target='.bd-example-modal-lg'>
            {t(SIDENAV_KEYS.TERMS_AND_CONDITIONS_KEYS.TITLE)}
          </span>
        </label>
      </label>
    </div>
  )
}
